module.exports = __webpack_public_path__ + "static/img/home_banner_01.78b5f86.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/home_banner_01.png
// module id = xifK
// module chunks = 0